import { Card } from "@ui/card";

import { ProgressBar } from "./ShadcnProgressBar";
import { SVG } from "../common/SVG";

interface LibraryProgressCardProps {
  image: string;
  progress: number;
  title: string;
  author: string;
  isCompleted?: boolean;
  onClick?: () => void;
  count?: number;
  countColorStyle?: string;
  isLocked?: boolean;
  hidePremiumIcon?: boolean;
}

const LibraryProgressCard = ({
  image,
  progress,
  title,
  author,
  isCompleted = false,
  onClick,
  count,
  countColorStyle,
  isLocked,
  hidePremiumIcon = false,
}: LibraryProgressCardProps) => {
  return (
    <Card
      className="relative flex max-w-[211px] cursor-pointer flex-col items-start justify-center gap-1 border-none p-3"
      onClick={onClick}
    >
      <div className="relative h-[200px] w-[211px] overflow-hidden rounded-[10px]">
        <img src={image} alt="No item" className="h-full w-full" />
        {isLocked && !hidePremiumIcon ? (
          <div className="absolute bottom-[11px] left-[15px] flex h-[31px] w-[31px] items-center justify-center rounded-full bg-[linear-gradient(180deg,_rgba(255,_204,_101,_0.90)_0%,_rgba(255,_191,_62,_0.95)_100%)]">
            <img src="/assets/icons/premium.svg" alt="premium" className="" />
          </div>
        ) : null}
      </div>
      <div className="flex w-full items-center justify-center gap-3">
        <ProgressBar value={progress} height="h-1" />
        <div className="text-primary">{progress}%</div>
      </div>
      <div className="flex items-center justify-between gap-2">
        <div>
          <div className="text-[20px] font-medium text-black dark:text-white">
            {title}
          </div>
          <div className="text-[16px] text-[#898A8D]">{author}</div>
        </div>
        {count ? (
          <div
            className={`flex h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full text-[20px] font-medium text-white ${countColorStyle}`}
          >
            {count}
          </div>
        ) : null}
      </div>
      {isCompleted && (
        <SVG
          src="/assets/b2c/icons/completed-content.svg"
          className="absolute bottom-5 end-3"
        />
      )}
    </Card>
  );
};

export default LibraryProgressCard;
